import {
  ACTN_IS_PROCESSING
} from './action-types.js';

const initialState = {
  keys: [],
  mostRecentStatus: false
};

const isProcessingReducer = function (state = initialState, action) {
  switch (action.type) {

    case ACTN_IS_PROCESSING:
      return {
        ...state,
        ...action.isProcessing
      }

    default:
      return state;
  }
};

export default isProcessingReducer;